import { Box } from "@mui/material";
import React from "react";
import CategoryTrends from "./CategoryTrends";
import ExpenseRangeGraph from "./ExpenseRangeGraph";

const ExpenseAnalytics = () => {
  return (
    <>
      <Box
        m="2rem 0"
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        gap={2}
        maxHeight={400}
      >
        <Box
          display="flex"
          flexDirection="column"
          width="52%"
          className="bg-slate-50 rounded-lg p-2 border-slate-500 align-middle h-auto"
        >
          <h4 className="text-center font-extrabold text-[0.72rem] leading-[0.5rem] text-[#666] mt-3">
            Expenses(₹) w.r.t Days
          </h4>
          <ExpenseRangeGraph />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width="45%"
          className="bg-slate-50 rounded-lg p-2 border-slate-500 align-middle justify-center"
        >
          <CategoryTrends />
        </Box>
      </Box>
    </>
  );
};

export default ExpenseAnalytics;
